import { Component, OnInit } from '@angular/core';
import { DashboardService } from '../dashboard.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { FormBuilder, Validators, FormGroup, FormArray } from '@angular/forms';
import { MustMatch } from 'src/app/data-service/must-match.validator';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { DatePipe } from '@angular/common';
import { LoaderService } from '../shared.service';

@Component({
  selector: 'app-add-admin-normal-users',
  templateUrl: './add-admin-normal-users.component.html',
  styleUrls: ['./add-admin-normal-users.component.scss']
})
export class AddAdminNormalUsersComponent implements OnInit {
  private ResponseVerifiedGetAllEpcUser: Subject<any> = new Subject();
  isEditing: any;
  userId: any;
  addNormalUserForm: FormGroup;
  emailList: FormArray;
  dataObject: {};
  isdevice: number;
  public adminEpcUserList: any;
  pipe = new DatePipe('en-US');
  editUserObject: { id: any; };
  addenergy_meter: any;
  energy_meter = false;
  marked = false;
  graph_inv: any;
  time: any = [{ "id": "14" }, { "id": "13" }, { "id": "12" }, { "id": "11" }, { "id": "10" }, { "id": "9" }, { "id": "8" }, { "id": "7" }, { "id": "6" }, { "id": "5" }, { "id": "4" }, { "id": "3" }, { "id": "2" }, { "id": "1" }];
  constructor(private fb: FormBuilder, private router: Router, private route: ActivatedRoute, private dashbord: DashboardService, 
    private toastr: ToastrService,private loaderService:LoaderService ) {
    this.route.queryParams.subscribe(params => {
      if (params.id) {
        this.isEditing = true;
        this.userId = params.id;
      }
    });
  }

  ngOnInit() {

    this.addNormalUserForm = this.fb.group({
      // We can set default values by passing in the corresponding value or leave blank if we wish to not set the value. For our example, we’ll default the gender to female.
      login_id: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      emails: this.fb.array([
        this.createEmailField()
      ]),
      password: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      mobile_no: ['', [Validators.pattern("^[0-9]*$"), Validators.minLength(10), Validators.maxLength(10)]],
      sim_no: ['', [Validators.pattern("^[0-9]*$"), Validators.minLength(10), Validators.maxLength(10)]],
      address: ['', [Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      epc_id: ['', [Validators.required]],
      instd_capacity: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,3})?$")]],
      num_inverter: ['', [Validators.required, Validators.pattern("^[0-9]*$")]],
      elec_rate: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,2})?$")]],
      start_dt: ['', Validators.required],
      end_dt: ['', Validators.required],
      solar_panel: ['', [Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      num_solar_panel: ['', [Validators.pattern("^[0-9]*$")]],
      confirmPassword: ['', Validators.required],
      energy_meter: [''],
      graph_interval: [''],
    }, {
      validator: MustMatch('password', 'confirmPassword')
    }
    );
    this.getAllEpcUser();
    if (this.isEditing == true) {
      this.getInfoByUserId();
    }
  }
  get f() { return this.addNormalUserForm.controls; }

  // email form array
  get emails(): FormArray {
    return this.addNormalUserForm.get('emails') as FormArray;
  }

  createEmailField(): FormGroup {
    return this.fb.group({
      email: ['', [Validators.pattern("[A-Za-z0-9._%+-]{1,}@[a-zA-Z0-9]{1,}([.]{1}[a-zA-Z0-9]{2,}|[.]{1}[a-zA-Z]{2,}[.]{1}[a-zA-Z]{2,})")]]
    });
  }

  // add email
  addEmail(): void {
    this.emails.push(this.createEmailField());
  }

  // remove email
  removeEmail(index: number): void {
    this.emails.removeAt(index);
  }

  onEpcChange(value) {

  }
  // get alladmin epc user list
  getAllEpcUser() {

    this.dataObject = {
      search: '',
      limit: 0,
      offset: 0
    }
    this.dashbord.getAllEpcUser(this.dataObject)
      .pipe(takeUntil(this.ResponseVerifiedGetAllEpcUser))
      .subscribe(
        async data => {
          if (data.status) {
            this.adminEpcUserList = data.resultObject.sort((a: { name: string; }, b: { name: any; }) => a.name.localeCompare(b.name));

            // this.adminEpcUserList = data.resultObject;

          } else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);

            } else {
              this.toastr.info(data.message);

            }

          }
        },
        err => {
          return console.error(err);
        }
      );
  }

  
  // add normal user
  add_user() {

    if (this.addNormalUserForm.value.energy_meter == true || this.addNormalUserForm.value.energy_meter == 'true') {
      this.addenergy_meter = 1;
    } else if (this.addNormalUserForm.value.energy_meter == false || this.addNormalUserForm.value.energy_meter == 'false') {
      this.addenergy_meter = 0;
    } if (this.addNormalUserForm.value.graph_interval == "") {
      this.graph_inv = "15";
    } else { this.graph_inv = this.addNormalUserForm.value.graph_interval; }

    var normalInfo =
    {
      "login_id": this.addNormalUserForm.controls['login_id'].value,
      "name": this.addNormalUserForm.controls['name'].value,
      "email": this.loaderService.convertEmailsInString(this.addNormalUserForm.value.emails),
      "password": this.addNormalUserForm.controls['password'].value,
      "mobile_no": this.addNormalUserForm.controls['mobile_no'].value,
      "address": this.addNormalUserForm.controls['address'].value,
      "sim_no": this.addNormalUserForm.controls['sim_no'].value,
      "instd_capacity": this.addNormalUserForm.controls['instd_capacity'].value,
      "num_inverter": this.addNormalUserForm.controls['num_inverter'].value,
      "elec_rate": this.addNormalUserForm.controls['elec_rate'].value,
      "start_dt": this.pipe.transform(this.addNormalUserForm.controls['start_dt'].value, "yyyy-MM-dd"),
      "end_dt": this.pipe.transform(this.addNormalUserForm.controls['end_dt'].value, "yyyy-MM-dd"),
      "solar_panel": this.addNormalUserForm.controls['solar_panel'].value,
      "num_solar_panel": this.addNormalUserForm.controls['num_solar_panel'].value,
      "epc_id": this.addNormalUserForm.controls['epc_id'].value,
      "is_emeter": this.addenergy_meter,
      "graph_interval": this.graph_inv
    }
    this.dashbord.addAdminNormalUser(normalInfo)
      .pipe(takeUntil(this.ResponseVerifiedGetAllEpcUser))
      .subscribe(data => {
        if (data.status === true || data.status === 'true') {
          this.toastr.success(data.message);
          this.router.navigate(['/inject-solar/admin-user-registration/admin-normal-users']);

        } else if (!data.status) {
          if (data.message == 'Unauthorised or Login Time-out') {
            this.toastr.info(data.message);
            this.router.navigate(["/login"]);

          } else {
            this.toastr.info(data.message);

          }

        }
      },
        err => {
          return console.log(err);
        })
  }
  //update normal user
  update_user() {
    if (this.addNormalUserForm.value.energy_meter == true || this.addNormalUserForm.value.energy_meter == 'true') {
      this.addenergy_meter = 1;
    } else if (this.addNormalUserForm.value.energy_meter == false || this.addNormalUserForm.value.energy_meter == 'false') {
      this.addenergy_meter = 0;
    }

    var normalInfo =
    {
      "id": this.userId,
      "login_id": this.addNormalUserForm.controls['login_id'].value,
      "name": this.addNormalUserForm.controls['name'].value,
      "email": this.loaderService.convertEmailsInString(this.addNormalUserForm.value.emails),
      "mobile_no": this.addNormalUserForm.controls['mobile_no'].value,
      "address": this.addNormalUserForm.controls['address'].value,
      "sim_no": this.addNormalUserForm.controls['sim_no'].value,
      "instd_capacity": this.addNormalUserForm.controls['instd_capacity'].value,
      "num_inverter": this.addNormalUserForm.controls['num_inverter'].value,
      "elec_rate": this.addNormalUserForm.controls['elec_rate'].value,
      "start_dt": this.pipe.transform(this.addNormalUserForm.controls['start_dt'].value, "yyyy-MM-dd"),
      "end_dt": this.pipe.transform(this.addNormalUserForm.controls['end_dt'].value, "yyyy-MM-dd"),
      "solar_panel": this.addNormalUserForm.controls['solar_panel'].value,
      "num_solar_panel": this.addNormalUserForm.controls['num_solar_panel'].value,
      "epc_id": this.addNormalUserForm.controls['epc_id'].value,
      "graph_interval": this.addNormalUserForm.controls['graph_interval'].value,
      "is_emeter": this.addenergy_meter,

    }
    this.dashbord.updateAdminNormalUser(normalInfo)
      .pipe(takeUntil(this.ResponseVerifiedGetAllEpcUser))
      .subscribe(data => {
        if (data.status === true || data.status === 'true') {
          this.toastr.success(data.message);
          this.router.navigate(['/inject-solar/admin-user-registration/admin-normal-users']);

        } else if (!data.status) {
          if (data.message == 'Unauthorised or Login Time-out') {
            this.toastr.info(data.message);
            this.router.navigate(["/login"]);
          } else {
            this.toastr.info(data.message);
          }

        }
      },
        err => {
          return console.log(err);
        })
  }
  // Epc Info By Id
  getInfoByUserId() {

    this.editUserObject = {
      id: this.userId
    };
    this.dashbord.getNormalInfoByUserId(this.editUserObject)
      .pipe(takeUntil(this.ResponseVerifiedGetAllEpcUser))
      .subscribe(
        async data => {
          if (data.status) {
            this.isdevice = data.resultObject[0].isdevice;
            var editEnergyMeter = data.resultObject[0].is_emeter;
            if (editEnergyMeter == 0) {
              this.marked = false;
              this.toggleVisibility(this.marked);
            }
            else if (editEnergyMeter == 1) {

              this.marked = true;
              this.toggleVisibility(this.marked);

            }
            if (this.isdevice) {
              this.addNormalUserForm.get('epc_id').disable();
            }

            const emails = this.loaderService.convertSrtingIntoArrayOfObj(data.resultObject[0].email);
            this.createEmailControls(emails);

            this.addNormalUserForm.get('login_id').setValue(data.resultObject[0].login_id);
            this.addNormalUserForm.get('name').setValue(data.resultObject[0].name);
            this.addNormalUserForm.get('emails').setValue(emails);
            this.addNormalUserForm.get('mobile_no').setValue(data.resultObject[0].mobile_no);
            this.addNormalUserForm.get('address').setValue(data.resultObject[0].address);
            this.addNormalUserForm.get('sim_no').setValue(data.resultObject[0].sim_no);;
            this.addNormalUserForm.get('instd_capacity').setValue(data.resultObject[0].instd_capacity);
            this.addNormalUserForm.get('num_inverter').setValue(data.resultObject[0].num_inverter);
            this.addNormalUserForm.get('elec_rate').setValue(data.resultObject[0].elec_rate);
            this.addNormalUserForm.get('start_dt').setValue(data.resultObject[0].start_dt);
            this.addNormalUserForm.get('end_dt').setValue(data.resultObject[0].end_dt);
            this.addNormalUserForm.get('solar_panel').setValue(data.resultObject[0].solar_panel);
            this.addNormalUserForm.get('num_solar_panel').setValue(data.resultObject[0].num_solar_panel);
            this.addNormalUserForm.get('epc_id').setValue(data.resultObject[0].epc_id);
            this.addNormalUserForm.get('graph_interval').setValue(data.resultObject[0].graph_interval);
            this.addNormalUserForm.get('password').setValue("password");
            this.addNormalUserForm.get('confirmPassword').setValue("password");
          } else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);
            } else {
              this.toastr.info(data.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }

  createEmailControls(emailArray) {
    for (let i = 1; i < emailArray.length; i++) {
      this.addEmail();
    }
  }

  ngOnDestroy() {
    this.ResponseVerifiedGetAllEpcUser.next();
    this.ResponseVerifiedGetAllEpcUser.complete();
  }
  
  toggleVisibility(e) {
    if (e == false) {
      this.marked = false;
      this.energy_meter = false;
    }
    else if (e == true) {
      this.marked = true;
      this.energy_meter = true;
    }

  }
  changeTime(e) {
  }
}
